// src/pages/stations/StationList.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import stationService from '../../services/stationService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';

const StationList = () => {
  const [stations, setStations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStations = async () => {
      const response = await stationService.getStations();
      setStations(response.data);
    };
    fetchStations();
  }, []);

  const handleDelete = async (id) => {
    await stationService.deleteStation(id);
    setStations(stations.filter((station) => station.id !== id));
  };

  return (
    <LayoutContainer>
      <AdminHeader title='Stations' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/stations/new')}
          >
            Add Station
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Station Name</TableCell>
              <TableCell>Station Type ID</TableCell>
              <TableCell>Latitude</TableCell>
              <TableCell>Longitude</TableCell>
              <TableCell>Event ID</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {stations.map((station) => (
              <TableRow key={station.id}>
                <TableCell>{station.station_name}</TableCell>
                <TableCell>{station.station_type_id}</TableCell>
                <TableCell>{station.latitude}</TableCell>
                <TableCell>{station.longitude}</TableCell>
                <TableCell>{station.event_id}</TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => navigate(`/stations/edit/${station.id}`)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(station.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default StationList;
